import Spacer from '@berlitz/spacer'
import Check from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/33-Form-Validation/Check'
import PortalLearningPathUnit from '@classes/LearningPathUnit'
import { Card, CardContent, CardHeader, Icon, IconCircle, InfoCard, InfoList, Title } from '@components/LPCard/Common'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { TopTag } from '../Lesson/style'
import { PFSubContainer } from './style'

export const PendingFeedback: React.FC<{ Unit: PortalLearningPathUnit }> = ({ Unit }) => (
  <Card type="speakingPanel" active={true}>
    <CardContent isElective={Unit?.IsFromElective}>
      <CardHeader>
        {Unit?.IsFromElective && (
          <TopTag color="info100">
            <FormattedMessage id="Elective" defaultMessage="Elective" />
          </TopTag>
        )}
        <Icon color="white">
          <IconCircle color="info100" />
          <Check />
        </Icon>
      </CardHeader>

      <Spacer size="md" />

      <Title color="info100">
        <FormattedMessage id="{name} completed" defaultMessage="{name} completed" values={{ name: Unit.LCSTitle }} />
      </Title>

      <Spacer size="sm" />

      <PFSubContainer>
        <InfoCard>
          <InfoList align="center" className="info-title">
            <FormattedMessage id="Instructor feedback in progress" />
          </InfoList>
        </InfoCard>
      </PFSubContainer>

      <Spacer size="md" />
    </CardContent>
  </Card>
)

export default PendingFeedback
